import React from 'react'
import { injectIntl } from 'react-intl';

import RDStation from '../../RDStation';
import CalendarIllustration from "../../../assets/agenda.svg"
import * as S from './Contact.styled'

const Contact = ({ intl, ...props }) => {
  return (
    <>
      <S.Contact id="section-contact">
        <div className="container grid">
          <div>
            <h2 className="title">{intl.messages.contact.title}</h2>
            <div className="subtitle">{intl.messages.contact.subtitle}</div>
          </div>
          <div />
        </div>

        <div className="container grid">
          <div>
            <CalendarIllustration className="calendar" />
          </div>
          <div>
            {intl.locale === 'pt-br' && (
              <RDStation
                portalId="20305269"
                formId="107b87dd-a44c-41f2-be54-281d05af8dba"
                loading={<div>Loading...</div>}
                onSubmit={() => window.lintrk('track', { conversion_id: 7846545 })}
              />
            )}
            {intl.locale !== 'pt-br' && (
              <RDStation
                portalId="20305269"
                formId="5b62f93c-8ddd-4050-bfa1-4bd2850f2d49"
                loading={<div>Loading...</div>}
                onSubmit={() => window.lintrk('track', { conversion_id: 7846569 })}
              />
            )}
            {/* <a style={{ textDecoration: 'none' }} id="schedule-presentation" aria-label="Calendry" target="_blank" rel="noreferrer" href="https://calendly.com/wepayout/"><button style={{ marginLeft: 22 }} className="button button--secondary button--medium">{intl.messages.contact.demo}</button></a> */}
          </div>
        </div>
      </S.Contact>
    </>
  )
}

export default injectIntl(Contact);